import { CreateSessionActions } from "@/features/coaching/components";
import { CreateSessionContextProvider } from "@/features/coaching/context";
import { AdminScreenContentLayout } from "@/features/coaching/layouts";
import {
  CreateSessionForm,
  CreateSessionHeader,
} from "@/features/coaching/sections";

export const CreateSession = () => {
  return (
    <AdminScreenContentLayout>
      <CreateSessionContextProvider>
        <CreateSessionHeader />

        <div className="grow">
          <CreateSessionForm />
        </div>

        <CreateSessionActions />
      </CreateSessionContextProvider>
    </AdminScreenContentLayout>
  );
};
